import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Col, Empty, message, Row, Space, Spin, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, Form, FormItem, InputItem, InputNumberItem, SwitchItem, TagItem, TextAreaItem } from "../../../Components/Items";

const formatoNumero = (valor) => Number(valor || 0).toLocaleString("es-MX");

class ModalPaquetesIa extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        paquetes: [],
        modalEditarVisible: false,
        paqueteEditado: null,
        sinLimite: false,
        interno: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) this.consultarPaquetes();
    }

    consultarPaquetes = () => {
        this.setState({ loading: true });
        axios
            .post("empresasBiwo/selectPaquetesIa", {}, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ loading: false, paquetes: res.data.success === 2 ? res.data.data : [] });
                if (res.data.success !== 2) message.error(res.data.message || "Error al consultar los paquetes de IA");
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error de red al consultar los paquetes de IA");
            });
    };

    abrirEditar = (paquete) => {
        this.setState({ modalEditarVisible: true, paqueteEditado: paquete, sinLimite: paquete?.sinLimite === true, interno: !paquete || paquete.interno === true });
    };

    cerrarEditar = () => {
        this.setState({ modalEditarVisible: false, paqueteEditado: null, sinLimite: false, interno: false });
    };

    guardarPaquete = () => {
        this.formRef.current.validateFields().then((values) => {
            this.setState({ loading: true });
            axios
                .post(
                    "empresasBiwo/guardarPaqueteIa",
                    { ...values, paqueteIaId: this.state.paqueteEditado?._id },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    if (res.data.success === 2) {
                        message.success(res.data.message);
                        this.cerrarEditar();
                        this.consultarPaquetes();
                    } else {
                        message.error(res.data.message || "Error al guardar el paquete de IA");
                    }
                })
                .catch(() => {
                    this.setState({ loading: false });
                    message.error("Error de red al guardar el paquete de IA");
                });
        });
    };

    render() {
        const paquete = this.state.paqueteEditado;
        const paquetes = [...this.state.paquetes].sort((a, b) => (b.activo === true) - (a.activo === true) || (a.precioMensual || 0) - (b.precioMensual || 0));

        return (
            <>
                <ModalItem
                    visible={this.props.visible}
                    title="Paquetes de IA"
                    onCancel={this.props.onCancel}
                    footer={null}
                    destroyOnClose
                    spinning={false}
                    paddingTop
                    width={900}
                >
                    <div className="paquetes-ia-encabezado" style={{ flexWrap: "wrap" }}>
                        <span>Solo se cuentan las consultas exitosas. Los paquetes de venta se editan en Catálogo, concepto IA.</span>
                        <ButtonItem morado botonAncho icon={<PlusOutlined />} onClick={() => this.abrirEditar(null)}>
                            Nuevo paquete interno
                        </ButtonItem>
                    </div>
                    <Spin spinning={this.state.loading}>
                        {paquetes.length === 0 ? (
                            <Empty description={this.state.loading ? "Cargando..." : "Aún no hay paquetes de IA"} />
                        ) : (
                            <div className="paquetes-ia-grid">
                                {paquetes.map((paquete) => (
                                    <div key={paquete._id} className={"paquete-ia-tarjeta" + (paquete.activo ? "" : " paquete-ia-inactivo")}>
                                        <div className="paquete-ia-titulo">
                                            <span>{paquete.nombre}</span>
                                            {paquete.interno && <TagItem morado>Interno</TagItem>}
                                            {paquete.deCatalogo && <TagItem azul>Catálogo</TagItem>}
                                            {paquete.activo ? <TagItem verdeNatural>Activo</TagItem> : <TagItem naranja>Inactivo</TagItem>}
                                        </div>
                                        <div className="paquete-ia-descripcion">{paquete.descripcion || "Sin descripción"}</div>
                                        {!paquete.interno && (
                                            <>
                                                <div className="paquete-ia-precio">
                                                    {Number(paquete.precioMensual || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                                                    <span> / mes</span>
                                                </div>
                                                <div className="paquete-ia-iva">Precio sin IVA</div>
                                            </>
                                        )}
                                        <div className="paquete-ia-limites">
                                            {paquete.sinLimite ? (
                                                <div><span>Consultas</span><b>Sin límite</b></div>
                                            ) : (
                                                <>
                                                    <div><span>Diarias</span><b>{formatoNumero(paquete.consultasDiarias)}</b></div>
                                                    <div><span>Mensuales</span><b>{formatoNumero(paquete.consultasMensuales)}</b></div>
                                                </>
                                            )}
                                        </div>
                                        <div className="paquete-ia-pie">
                                            <span>{paquete.empresas === 1 ? "1 empresa" : `${paquete.empresas} empresas`}</span>
                                            {!paquete.deCatalogo && (
                                                <Tooltip title="Editar">
                                                    <ButtonItem size="small" morado icon={<EditOutlined />} onClick={() => this.abrirEditar(paquete)} />
                                                </Tooltip>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Spin>
                </ModalItem>
                <ModalItem
                    visible={this.state.modalEditarVisible}
                    title={paquete ? "Editar paquete de IA" : "Nuevo paquete interno de IA"}
                    onCancel={this.cerrarEditar}
                    footer={null}
                    destroyOnClose
                    spinning={this.state.loading}
                    paddingTop
                    width={550}
                >
                    <Form
                        ref={this.formRef}
                        name="paqueteIa"
                        layout
                        onValuesChange={(cambios) => {
                            if ("sinLimite" in cambios) this.setState({ sinLimite: cambios.sinLimite });
                            if ("interno" in cambios) this.setState({ interno: cambios.interno });
                        }}
                        bottom={
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Space size={8}>
                                    <ButtonItem danger onClick={this.cerrarEditar}>Cancelar</ButtonItem>
                                    <ButtonItem morado onClick={this.guardarPaquete}>Guardar</ButtonItem>
                                </Space>
                            </div>
                        }
                    >
                        <Row>
                            <Col span={24}>
                                <FormItem label="Nombre" name="nombre" margin required max={80} initialValue={paquete?.nombre}>
                                    <InputItem placeholder="Nombre del paquete" />
                                </FormItem>
                                <FormItem label="Descripción" name="descripcion" margin max={500} initialValue={paquete?.descripcion}>
                                    <TextAreaItem placeholder="Descripción del paquete" rows={3} />
                                </FormItem>
                                <FormItem label="Sin límite" name="sinLimite" margin valuePropName="checked" initialValue={paquete?.sinLimite === true}>
                                    <SwitchItem />
                                </FormItem>
                                {!this.state.sinLimite && (
                                    <>
                                        <FormItem label="Consultas diarias" name="consultasDiarias" margin required initialValue={paquete?.consultasDiarias}>
                                            <InputNumberItem placeholder="Consultas por día" precision={0} min={1} />
                                        </FormItem>
                                        <FormItem label="Consultas mensuales" name="consultasMensuales" margin required initialValue={paquete?.consultasMensuales}>
                                            <InputNumberItem placeholder="Consultas por mes calendario" precision={0} min={1} />
                                        </FormItem>
                                    </>
                                )}
                                {paquete && (
                                <FormItem
                                    label="Interno"
                                    name="interno"
                                    margin
                                    valuePropName="checked"
                                    initialValue={paquete.interno === true}
                                    extra="No se ofrece a las empresas y no lleva precio"
                                >
                                    <SwitchItem />
                                </FormItem>
                                )}
                                {!this.state.interno && (
                                <FormItem
                                    label="Precio mensual"
                                    name="precioMensual"
                                    margin
                                    required
                                    initialValue={paquete?.precioMensual ?? 0}
                                    extra="Precio en pesos mexicanos, sin IVA"
                                >
                                    <InputNumberItem placeholder="Precio al mes sin IVA" dinero min={0} />
                                </FormItem>
                                )}
                                <FormItem label="Activo" name="activo" margin valuePropName="checked" initialValue={paquete ? paquete.activo !== false : true}>
                                    <SwitchItem />
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalPaquetesIa);
